export const white = "#FFFFFF";
export const black = "#000000";
export const babyblue = "#92C1E9";
export const sunny = "#FF9800";
export const liteSunny = "#FDEACC";
export const sunset = "#EA7600";
export const graphite = "#63666A";

export const gray0 = "#FAFAFA";
export const gray1 = "#F0F0F0";
export const gray2 = "#E1E1E1";
export const gray3 = "#D2D2D2";
export const gray4 = "#A5A5A5";
export const gray5 = "#979797";
export const gray6 = "#757575";
export const gray7 = "#5B5D62";
export const gray8 = "#4A4C53";
export const gray9 = "#212121";
export const gray10 = "#bbbbbb";
export const gray11 = "#e5e5e5";
export const gray12 = "#595c61";
export const gray13 = "#E0E0E0";
export const gray14 = "#E9E9E9";
export const lightGreen = "#e9f0e1";
export const lightBlue = "#eff6fc";
